angular
  .module("AccountingBoxApp")
  .controller("SalesListCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    Sale
  ) {
    $scope.order = {
      by: "invoiceDate",
      reverse: true,
      filter: ""
    };

    var datasource = {};

    var vm = this;

    vm.queryChanged = _.debounce(function() {
      queryChanged();
    }, 300);
    vm.datasource = datasource;
    vm.reloadTable = reloadTable;
    vm.itemsCount = 0;

    function reloadTable() {
      if ($scope.adapter) {
        $scope.adapter.reload();
      }
    }

    $scope.$watch("adapter", function() {
      reloadTable();
    });

    var filteredDataMemoized = _.memoize(filteredData, function resolver() {
      return JSON.stringify(arguments);
    });

    function filteredData(order, result) {
      var options = {
        shouldSort: true,
        threshold: 0.05,
        location: 0,
        distance: 10000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "customer.name",
          "invoiceNumber",
          "totalAmount",
          // "Lines.account.description",
          // "Lines.account.accountNumber",
          // "Lines.account.subCategory.description",
          "vatCodes",
          "statusText",
          "invoiceDateFormattedShort",
          "invoiceDateFormattedLong",
          "totalAmountFormattted"
        ]
      };
      if (order.filter && order.filter.length > 0) {
        var fuse = new Fuse(result, options); // "list" is the item array
        result = fuse.search(order.filter);
        result = result.map((t) => t.item);
      }
      result = $filter("orderBy")(result, order.by, order.reverse);
      return result;
    }

    datasource.get = function(index, count, success) {
      var result = vm.sales || [];
      result = filteredDataMemoized($scope.order, result);
      vm.itemsCount = result.length;
      result = result.slice(index - 1, index - 1 + count);
      return success(result);
    };
    //set query based on url
    $scope.$watch(
      function() {
        return $location.url();
      },
      function(url) {
        if (url) {
          $scope.order.filter = $location.search().q;
        }
      }
    );
    var lastKeyword = "";

    function queryChanged() {
      var q = $scope.order.filter;
      if (q) {
        $location.search("q", $scope.order.filter);
      } else {
        $location.search("q", null);
      }
      if (!lastKeyword) {
        lastKeyword = "";
      }
      lastKeyword = q;
      reloadTable();
    }

    //cache disabled
    vm.loading = true;

    vm.year = $rootScope.defaultDisplayYear;
    vm.yearChanged = function() {
      refreshData();
    };

    function refreshData() {
      var filter = {
        include: {
          relation: "customer",
          scope: {
            fields: {
              name: true,
              website: true
            }
          }
        },

        where: {}
      };
      var dateFilter = $rootScope.displayDateFilter(vm.year);
      if (dateFilter) {
        filter.where.invoiceDate = dateFilter;
      }

      vm.sales = Sale.find(
        {
          filter: filter
        },
        function() {
          vm.sales = vm.sales.map(function(i) {
            i.invoiceDateFormattedShort = moment(i.invoiceDate).format("L");
            i.invoiceDateFormattedLong = moment(i.invoiceDate).format("LL");
            i.totalAmountFormattted = $filter("currency")(
              i.totalAmount,
              "NONE",
              2
            );
            return i;
          });

          reloadTable();
          vm.loading = false;
        }
      );
    }

    refreshData();

    //cache enabled:
    /*var sales = Sale.find({filter: {include: 'Customer'}});
          sales.$httpPromise.then(function () {
              reloadTable();
          });*/

    vm.viewSale = function(sale) {
      vm.editSale(sale);
    };
    vm.editSale = function(sale) {
      $state.go("app.company.edit.sales", { id: sale.id, sale: sale });
    };
    vm.newSale = function() {
      $state.go("app.company.new.sales");
    };
  });
